export default "__VITE_PUBLIC_ASSET__64201248__"